import { API, Endpoints, unpackEndpoint } from "@brg/api";
import { useEffect, useState } from "react";

const endpoint = unpackEndpoint({
    develop: 'https://api.burgdev.ru/ratings',
    staging: 'https://api.burgstg.ru/ratings',
    production: 'https://api.mediiia.ru/ratings',
    hseOnline: 'https://api.hsedesign.online/ratings',
})

const disciplineOwnerTypes: any = {
    'teachers': 1,
    'students': 0
}

export const useGetMetrics = (language = 'ru', isAuthorized?: boolean, disciplineOwnerType?: string) => {

    const [metrics, setMetrics] = useState([])

    useEffect(() => {
        if (isAuthorized) {
            API.fetch(`${endpoint}/api/ratings/Metrics?DisciplineOwnerType=${disciplineOwnerType? disciplineOwnerTypes[disciplineOwnerType] : 0}`,{method: 'GET'})
                .then(r => r.json()
                    .then((json: any) => setMetrics(API.toLang(json, language))))
        }
    }, [isAuthorized])

    return metrics
}

export const useGetDisciplines = (language = 'ru', isAuthorized?: boolean, disciplineOwnerType?: string) => {
    const [disciplines, setDisciplines] = useState([])

        useEffect(() => {
            if (isAuthorized) {
                API.fetch(`${endpoint}/api/ratings/Disciplines?DisciplineOwnerType=${disciplineOwnerType? disciplineOwnerTypes[disciplineOwnerType] : 0}`,{method: 'GET'})
                .then(r => r.json()
                    .then((json: any) => setDisciplines(API.toLang(json, language))))
            }            
        }, [isAuthorized])

    return disciplines
}

export const useGetEduTags = (language = 'ru', metric: any, timePeriod: any, isAuthorized?: boolean) => {
    
    const [tags, setTags] = useState([])

    const {needBlackTag, name: metricName, disciplineType, id} = metric || {}
    const {timeIntervalType, date} = timePeriod || {}

    useEffect(() => {
        if (!(needBlackTag && timePeriod && metric) || !isAuthorized) return
            API.request()
                .endpoint(endpoint)
                .url('api/ratings/ActiveProjectTags')
                .get()
                .addQuery('metricId', id)
                .addQuery('metricsName', metricName)
                .addQuery('date', date)
                .addQuery('intervalType', timeIntervalType)
                .send()
                .then(res => res.json())
                .then(json => setTags(API.toLang(json, language)))

    }, [metric, timePeriod, isAuthorized])

    return tags
}


export const useGetCurrentAndPreviousUsersProjectTags = (language = 'ru', profile?: any, isAuthorized? : boolean): any => {

    const [сurrentAndPreviousUsersProjectTags, setCurrentAndPreviousUsersProjectTags] = useState([])

    useEffect(() => {
        if (!profile || !isAuthorized) return
        API.fetch(`${endpoint}/api/ratings/CurrentAndPreviousUsersProjectTags`,{method: 'GET'})
            .then(r => r.json()
                .then((json: any) => setCurrentAndPreviousUsersProjectTags(API.toLang(json, language))))
    }, [profile, isAuthorized])

    return сurrentAndPreviousUsersProjectTags
}


export const useGetTeachersRatings = (metricsParams: any, language: string = 'ru',  isAuthorized?: boolean) => {
    // TeachersRatingsByDiscipline

     const {page, limit, date, metricId, disciplineType, intervalType, userId} = metricsParams
    const [teachers, setTeachers] = useState<any>([])
    const [paging, setPaging] = useState<any>()
    const [requestedUser, setRequestedUser] = useState<any>()
  
    useEffect(() => {
        if (!(date && intervalType && page && limit && disciplineType) ||
            !isAuthorized) {
                setTeachers([])
                return
            }

        const getTeachersRatings = () => {
            return API.request()
                .endpoint(endpoint)
                .url('/api/ratings/TeachersRatingsByDiscipline')
                .get()
                .addQuery('disciplineType', disciplineType)
                .addQuery('limit', limit)
                .addQuery('page', page)
                .addQuery('intervalType', intervalType)
                .addQuery('date', date)
                .addQuery('userId', userId? userId : '')
                .send()
        }

        if (page === 1) {
            setTeachers([])
        }

        getTeachersRatings()
            .then(res => res.json())
            .then(json => {
                const response: any = API.toLang(json.data, language)
                setTeachers(page === 1 ? response.studentsWithRating : [...teachers, ...response.studentsWithRating])
                setRequestedUser(response.requestedUserWithPosition)
                setPaging(json.paging)
            })
    }, [page, limit, date, metricId, disciplineType, intervalType, language, userId, isAuthorized])

    return [teachers, paging, requestedUser]
}


export const useGetStrudentsRating = (metricsType: string, metricsParams: any, language: string = 'ru', needCategoryValue?: boolean, isAuthorized?: boolean) => {

    const {page, limit, date, categoryValue, metricId, disciplineType, intervalType, userId} = metricsParams
    const [students, setStudents] = useState<any>([])
    const [paging, setPaging] = useState<any>()
    const [requestedUser, setRequestedUser] = useState<any>()
  
    useEffect(() => {
        if (!(date && intervalType && page && limit && disciplineType) || 
            (metricsType === 'metrics' && (!metricId || (needCategoryValue && !categoryValue))) ||
            !isAuthorized) {
                setStudents([])
                return
            }
        const studentsByMetrics = () => {
            return API.request()
                .endpoint(endpoint)
                .url('/api/ratings/StudentsRatingByMetric')
                .get()
                .addQuery('metricId', metricId)
                .addQuery('limit', limit)
                .addQuery('page', page)
                .addQuery('intervalType', intervalType)
                .addQuery('date', date)
                .addQuery('categoryValue', needCategoryValue? categoryValue : '')
                .addQuery('userId', userId? userId : '')
                .send()
        }

        const studentsPointsByDiscipline = () => {
            return API.request()
                .endpoint(endpoint)
                .url('/api/ratings/StudentsPointsByDiscipline')
                .get()
                .addQuery('disciplineType', disciplineType)
                .addQuery('limit', limit)
                .addQuery('page', page)
                .addQuery('intervalType', intervalType)
                .addQuery('date', date)
                .addQuery('userId', userId? userId : '')
                .send()
        }

        if (page === 1) {
            setStudents([])
        }

        if (metricsType === 'metrics') {
            studentsByMetrics()
                .then(res => res.json())
                .then(json => {
                    const response: any = API.toLang(json.data, language)
                    setStudents(page === 1 ? response.studentsWithRating : [...students, ...response.studentsWithRating])
                    setRequestedUser(response.requestedUserWithPosition)
                    setPaging(json.paging)
                })
                return
        }

        studentsPointsByDiscipline()
            .then(res => res.json())
            .then(json => {
                const response: any = API.toLang(json.data, language)
                setStudents(page === 1 ? response.studentsWithRating : [...students, ...response.studentsWithRating])
                setRequestedUser(response.requestedUserWithPosition)
                setPaging(json.paging)
            })
    }, [metricsType, page, limit, date, categoryValue, metricId, disciplineType, intervalType, language, userId, isAuthorized])

    return [students, paging, requestedUser]
}import { API, Endpoints, unpackEndpoint } from "@brg/api";
import { useEffect, useState } from "react";

const endpoint = unpackEndpoint({
    develop: 'https://api.burgdev.ru/ratings',
    staging: 'https://api.burgstg.ru/ratings',
    production: 'https://api.mediiia.ru/ratings',
    hseOnline: 'https://api.hsedesign.online/ratings',
})

const disciplineOwnerTypes: any = {
    'teachers': 1,
    'students': 0
}

export const useGetMetrics = (language = 'ru', isAuthorized?: boolean, disciplineOwnerType?: string) => {

    const [metrics, setMetrics] = useState([])

    useEffect(() => {
        if (isAuthorized) {
            API.fetch(`${endpoint}/api/ratings/Metrics?DisciplineOwnerType=${disciplineOwnerType? disciplineOwnerTypes[disciplineOwnerType] : 0}`,{method: 'GET'})
                .then(r => r.json()
                    .then((json: any) => setMetrics(API.toLang(json, language))))
        }
    }, [isAuthorized])

    return metrics
}

export const useGetDisciplines = (language = 'ru', isAuthorized?: boolean, disciplineOwnerType?: string) => {
    const [disciplines, setDisciplines] = useState([])

        useEffect(() => {
            if (isAuthorized) {
                API.fetch(`${endpoint}/api/ratings/Disciplines?DisciplineOwnerType=${disciplineOwnerType? disciplineOwnerTypes[disciplineOwnerType] : 0}`,{method: 'GET'})
                .then(r => r.json()
                    .then((json: any) => setDisciplines(API.toLang(json, language))))
            }            
        }, [isAuthorized])

    return disciplines
}

export const useGetEduTags = (language = 'ru', metric: any, timePeriod: any, isAuthorized?: boolean) => {
    
    const [tags, setTags] = useState([])

    const {needBlackTag, name: metricName, disciplineType, id} = metric || {}
    const {timeIntervalType, date} = timePeriod || {}

    useEffect(() => {
        if (!(needBlackTag && timePeriod && metric) || !isAuthorized) return
            API.request()
                .endpoint(endpoint)
                .url('api/ratings/ActiveProjectTags')
                .get()
                .addQuery('metricId', id)
                .addQuery('metricsName', metricName)
                .addQuery('date', date)
                .addQuery('intervalType', timeIntervalType)
                .send()
                .then(res => res.json())
                .then(json => setTags(API.toLang(json, language)))

    }, [metric, timePeriod, isAuthorized])

    return tags
}


export const useGetCurrentAndPreviousUsersProjectTags = (language = 'ru', profile?: any, isAuthorized? : boolean): any => {

    const [сurrentAndPreviousUsersProjectTags, setCurrentAndPreviousUsersProjectTags] = useState([])

    useEffect(() => {
        if (!profile || !isAuthorized) return
        API.fetch(`${endpoint}/api/ratings/CurrentAndPreviousUsersProjectTags`,{method: 'GET'})
            .then(r => r.json()
                .then((json: any) => setCurrentAndPreviousUsersProjectTags(API.toLang(json, language))))
    }, [profile, isAuthorized])

    return сurrentAndPreviousUsersProjectTags
}


export const useGetTeachersRatings = (metricsParams: any, language: string = 'ru',  isAuthorized?: boolean) => {
    // TeachersRatingsByDiscipline

     const {page, limit, date, metricId, disciplineType, intervalType, userId} = metricsParams
    const [teachers, setTeachers] = useState<any>([])
    const [paging, setPaging] = useState<any>()
    const [requestedUser, setRequestedUser] = useState<any>()
  
    useEffect(() => {
        if (!(date && intervalType && page && limit && disciplineType) ||
            !isAuthorized) {
                setTeachers([])
                return
            }

        const getTeachersRatings = () => {
            return API.request()
                .endpoint(endpoint)
                .url('/api/ratings/TeachersRatingsByDiscipline')
                .get()
                .addQuery('disciplineType', disciplineType)
                .addQuery('limit', limit)
                .addQuery('page', page)
                .addQuery('intervalType', intervalType)
                .addQuery('date', date)
                .addQuery('userId', userId? userId : '')
                .send()
        }

        if (page === 1) {
            setTeachers([])
        }

        getTeachersRatings()
            .then(res => res.json())
            .then(json => {
                const response: any = API.toLang(json.data, language)
                setTeachers(page === 1 ? response.studentsWithRating : [...teachers, ...response.studentsWithRating])
                setRequestedUser(response.requestedUserWithPosition)
                setPaging(json.paging)
            })
    }, [page, limit, date, metricId, disciplineType, intervalType, language, userId, isAuthorized])

    return [teachers, paging, requestedUser]
}


export const useGetStrudentsRating = (metricsType: string, metricsParams: any, language: string = 'ru', needCategoryValue?: boolean, isAuthorized?: boolean) => {

    const {page, limit, date, categoryValue, metricId, disciplineType, intervalType, userId} = metricsParams
    const [students, setStudents] = useState<any>([])
    const [paging, setPaging] = useState<any>()
    const [requestedUser, setRequestedUser] = useState<any>()
  
    useEffect(() => {
        if (!(date && intervalType && page && limit && disciplineType) || 
            (metricsType === 'metrics' && (!metricId || (needCategoryValue && !categoryValue))) ||
            !isAuthorized) {
                setStudents([])
                return
            }
        const studentsByMetrics = () => {
            return API.request()
                .endpoint(endpoint)
                .url('/api/ratings/StudentsRatingByMetric')
                .get()
                .addQuery('metricId', metricId)
                .addQuery('limit', limit)
                .addQuery('page', page)
                .addQuery('intervalType', intervalType)
                .addQuery('date', date)
                .addQuery('categoryValue', needCategoryValue? categoryValue : '')
                .addQuery('userId', userId? userId : '')
                .send()
        }

        const studentsPointsByDiscipline = () => {
            return API.request()
                .endpoint(endpoint)
                .url('/api/ratings/StudentsPointsByDiscipline')
                .get()
                .addQuery('disciplineType', disciplineType)
                .addQuery('limit', limit)
                .addQuery('page', page)
                .addQuery('intervalType', intervalType)
                .addQuery('date', date)
                .addQuery('userId', userId? userId : '')
                .send()
        }

        if (page === 1) {
            setStudents([])
        }

        if (metricsType === 'metrics') {
            studentsByMetrics()
                .then(res => res.json())
                .then(json => {
                    const response: any = API.toLang(json.data, language)
                    setStudents(page === 1 ? response.studentsWithRating : [...students, ...response.studentsWithRating])
                    setRequestedUser(response.requestedUserWithPosition)
                    setPaging(json.paging)
                })
                return
        }

        studentsPointsByDiscipline()
            .then(res => res.json())
            .then(json => {
                const response: any = API.toLang(json.data, language)
                setStudents(page === 1 ? response.studentsWithRating : [...students, ...response.studentsWithRating])
                setRequestedUser(response.requestedUserWithPosition)
                setPaging(json.paging)
            })
    }, [metricsType, page, limit, date, categoryValue, metricId, disciplineType, intervalType, language, userId, isAuthorized])

    return [students, paging, requestedUser]
}